<app-audit-subbar></app-audit-subbar>

<div class="audit-tab-body" style="position: relative">
  <div class="ov-wrap">
    <!-- ===== LOADING STATE ===== -->
    <div class="ov-loader-section" *ngIf="showLoader && !noData">
      <div class="ov-loader-svg">
        <svg
          width="200"
          height="161"
          viewBox="0 0 200 161"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M46 47.5L71.5 62.5L97.5 47.5V17L71.5 2L46 17V47.5Z"
            [style.stroke]="loaderPercentage > 10 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M18 96.5L43.5 111.5L69.5 96.5V66L43.5 51L18 66V96.5Z"
            [style.stroke]="loaderPercentage > 20 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M102 46.5L127.5 61.5L153.5 46.5V16L127.5 1L102 16V46.5Z"
            [style.stroke]="loaderPercentage > 30 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M75 95.5L100.5 110.5L126.5 95.5V65L100.5 50L75 65V95.5Z"
            [style.stroke]="loaderPercentage > 35 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M102 144.5L127.5 159.5L153.5 144.5V114L127.5 99L102 114V144.5Z"
            [style.stroke]="loaderPercentage > 40 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M107 75L98 84.5L93.5 80"
            [style.stroke]="loaderPercentage > 50 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M131 95.5L156.5 110.5L182.5 95.5V65L156.5 50L131 65V95.5Z"
            [style.stroke]="loaderPercentage > 60 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M46 144.5L71.5 159.5L97.5 144.5V114L71.5 99L46 114V144.5Z"
            [style.stroke]="loaderPercentage > 70 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M1 137.818L14.8641 146L29 137.818V121.182L14.8641 113L1 121.182V137.818Z"
            [style.stroke]="loaderPercentage > 80 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
          <path
            d="M171 38.8182L184.864 47L199 38.8182V22.1818L184.864 14L171 22.1818V38.8182Z"
            [style.stroke]="loaderPercentage > 90 ? '#8680ff' : '#c9c6cc'"
            stroke-width="1.5"
          />
        </svg>
      </div>
      <div class="multi_lines_loading_text_container">
        <div class="multi_lines_loading_text">
          <p
            *ngFor="let message of loaderTexts; let i = index"
            [ngClass]="{
              active: i == loaderLineIndex,
              before: i < loaderLineIndex,
              after: i > loaderLineIndex,
            }"
          >
            {{ message }}
          </p>
        </div>
      </div>
    </div>

    <!-- ===== NO DATA STATE ===== -->
    <div class="ov-empty" *ngIf="noData">
      <p>You don't have any audits yet.</p>
      <div class="custom-buttons_container">
        <button mat-raised-button type="button" (click)="addAudit()">
          <mat-icon class="button-icon">add</mat-icon>
          <span>Create Audit</span>
        </button>
      </div>
    </div>

    <!-- ===== MAIN CONTENT ===== -->
    <ng-container *ngIf="!showLoader && !noData && overviewData">
      <!-- ── Executive Summary ── -->
      <div class="exec-card">
        <div class="exec-card-header">
          <span class="exec-dot"></span>
          <span class="exec-label">EXECUTIVE SUMMARY</span>
        </div>

        <p class="exec-summary-text" *ngIf="summaryHeadline || summaryText">
          <b *ngIf="summaryHeadline">{{ summaryHeadline }}</b>
          <span *ngIf="summaryText"> {{ summaryText }}</span>
        </p>

        <div class="kpi-grid">
          <!-- Overall Health -->
          <div class="kpi-card">
            <div class="kpi-name">Overall Health</div>
            <div class="kpi-val-row">
              <span class="kpi-val">{{ kpiHealth }}</span>
              <span class="kpi-unit">/100</span>
              <span
                class="kpi-delta"
                *ngIf="kpiHealthDelta !== null && kpiHealthDelta !== 0"
                [style.color]="kpiHealthDelta > 0 ? green : red"
              >
                {{
                  kpiHealthDelta > 0
                    ? "▲ +" + kpiHealthDelta
                    : "▼ " + -kpiHealthDelta
                }}
              </span>
            </div>
            <div class="kpi-spark" *ngIf="kpiHealthSpark.length > 1">
              <audit-sparkline
                [values]="kpiHealthSpark"
                [color]="accent"
              ></audit-sparkline>
            </div>
            <div class="kpi-hint">vs last period</div>
          </div>

          <!-- Market Position -->
          <div class="kpi-card">
            <div class="kpi-name">Market Position</div>
            <div class="kpi-val-row">
              <span class="kpi-val kpi-rank"
                >{{ kpiRank
                }}<span class="kpi-rank-suffix">{{
                  kpiRank === 1
                    ? "st"
                    : kpiRank === 2
                      ? "nd"
                      : kpiRank === 3
                        ? "rd"
                        : "th"
                }}</span></span
              >
              <span class="kpi-unit"
                >of {{ kpiRankTotal }}
                {{ kpiRankTotal === 1 ? "site" : "sites" }}</span
              >
            </div>
            <div class="kpi-hint">{{ kpiRankNote }}</div>
          </div>

          <!-- Strongest advantage -->
          <div class="kpi-card" *ngIf="hasAdvantage">
            <div class="kpi-name">Strongest advantage</div>
            <div class="kpi-val-row">
              <span class="kpi-val kpi-val--text" [style.color]="advColor">{{
                advArea
              }}</span>
              <span
                class="kpi-delta"
                *ngIf="advDiffText"
                [style.color]="advColor"
                >{{ advDiffText }}</span
              >
            </div>
            <div class="kpi-hint">{{ advNote }}</div>
          </div>
        </div>
      </div>

      <!-- Top hidden potentials — the first rows of the Opportunities roll-up -->
      <div class="exec-potentials" *ngIf="topPotentials.length">
        <h3 class="section-title">Top hidden potentials</h3>
        <p class="exec-potentials-desc">{{ topPotentialsDesc }}</p>

        <div class="custom_table-container custom_table-container-v2">
          <table class="custom_table pot-table">
            <!-- Widths live in CSS (not inline) so they can tighten on narrower
                 viewports — see overview.component.css. -->
            <colgroup>
              <col class="pot-col-idx" />
              <col class="pot-col-name" />
              <col class="pot-col-ev" />
              <col class="pot-col-rel" />
              <col class="pot-col-conf" />
            </colgroup>
            <thead>
              <tr>
                <th><div>#</div></th>
                <th><div>Opportunity</div></th>
                <th><div>Evidence</div></th>
                <th><div>Commercial relevance</div></th>
                <th><div>Confidence</div></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let o of topPotentials; let i = index">
                <td class="pot-index">{{ i + 1 }}</td>
                <td>
                  <div class="pot-name">{{ o.title }}</div>
                  <div class="pot-page" *ngIf="o.page">{{ o.page }}</div>
                </td>
                <td class="pot-evidence">{{ o.evidence }}</td>
                <td class="pot-reason">{{ o.reason }}</td>
                <td>
                  <span class="pot-badge" [ngClass]="o.confidenceClass">{{
                    o.confidenceLabel
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pot-viewall">
            <button
              type="button"
              class="pot-viewall-link"
              (click)="goToTabIndex(1)"
            >
              View all opportunities
            </button>
          </div>
        </div>
      </div>

      <!-- ── Credible strength + category snapshot ── -->
      <div
        class="ov-snapshot-grid"
        [class.ov-snapshot-grid--single]="!credibleStrength || !catBars.length"
      >
        <!-- One credible strength — summary.oneCredibleStrength -->
        <div class="strength-card" *ngIf="credibleStrength">
          <div class="strength-head">
            <span class="strength-icon">
              <mat-icon>check</mat-icon>
            </span>
            <h3 class="card-title">One credible strength</h3>
          </div>
          <p class="strength-text">{{ credibleStrength }}</p>
        </div>

        <!-- Category snapshot -->
        <div class="strength-card" *ngIf="catBars.length">
          <div class="section-header">
            <h3 class="card-title">Category scores</h3>
            <span class="section-hint">{{ catBarsNote }}</span>
          </div>

          <div class="cat-bars">
            <div
              class="cat-bar-row"
              *ngFor="let b of catBars"
              [class.cat-bar-row--clickable]="b.tabIndex !== null"
              [matTooltip]="b.tooltip"
              matTooltipPosition="above"
              (click)="goToTabIndex(b.tabIndex)"
            >
              <span class="cat-bar-label">{{ b.label }}</span>
              <div class="cat-bar-track">
                <span class="cat-bar-center" *ngIf="catBarsDiverging"></span>
                <span
                  class="cat-bar-fill"
                  *ngIf="b.width"
                  [style.left.%]="b.left"
                  [style.width.%]="b.width"
                  [style.background]="b.color"
                ></span>
              </div>
              <span class="cat-bar-val" [style.color]="b.valueColor">{{
                b.valueText
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Booking CTA (same meeting link as the shared audit page) ── -->
      <div class="ov-cta">
        <button type="button" class="ov-cta-btn" (click)="openHubspot()">
          Book the 60-minute stakeholder workshop
        </button>
      </div>
    </ng-container>
  </div>

  <!-- Competitor switch overlay (scoped to the content, below the sub-bar) -->
  <div class="loading-data-overlay" *ngIf="competitorSwitching$ | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <!-- ===== LOADING OVERLAY ===== -->
  <div class="loading-data-overlay" *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
